import { render, staticRenderFns } from "./EditOptionList.vue?vue&type=template&id=58cd3d95"
import script from "./EditOptionList.vue?vue&type=script&lang=js"
export * from "./EditOptionList.vue?vue&type=script&lang=js"
import style0 from "./EditOptionList.vue?vue&type=style&index=0&id=58cd3d95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports